export default __webpack_public_path__ + "static/media/A_06_01_bg_v02.414cd8f2.mp4";